
const SecondaryMarketActionTypes = {
    FETCH_SECONDARY_MARKET_START: "FETCH_SECONDARY_MARKET_START",
    FETCH_SECONDARY_MARKET_SUCCESS: "FETCH_SECONDARY_MARKET_SUCCESS",
    FETCH_SECONDARY_MARKET_FAILURE: "FETCH_SECONDARY_MARKET_FAILURE",
  };
  
  export default SecondaryMarketActionTypes;
  